import { FunctionComponent, ReactNode } from "react";

import { CskLiveResourceMetadataProvider } from "src/context/CskLiveResourceMetadataContext";

interface Props {
  nodeId: string;
  /** When true, fetches publish-time fields client-side after hydration. */
  refreshLiveMetadata?: boolean;
  children: ReactNode;
}

/**
 * Wraps CSK story content so lede + metadata siblings share one live-metadata
 * refresh (Relay store update). Place around MetadataContainer and LedeContainer.
 */
const CskStoryLiveMetadataShell: FunctionComponent<Props> = ({
  nodeId,
  refreshLiveMetadata = false,
  children,
}) => {
  return (
    <CskLiveResourceMetadataProvider
      nodeId={nodeId}
      enabled={refreshLiveMetadata}
    >
      {children}
    </CskLiveResourceMetadataProvider>
  );
};

export default CskStoryLiveMetadataShell;
